import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { isAuthenticated, role, bootstrapped } = useSelector(state => state.auth);

      if (!bootstrapped) {
        return <div>Loading...</div>;
      }    

  if (!isAuthenticated) {
    return <Navigate to="/login/select-role" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;